let message = {
    pushsn: "流水号",
    deviceCode: "设备号",
    merchantName: "商户名称",
    merchantCode: "商户编号",
    content: "播报内容",
    pushTime: "推送时间",
    responseTime: "响应时间",
    pushResult: "响应结果",
    appId: "应用",
    resultTrue: "播报成功",
    resultFalse: "未播报",
    orgName: "组织机构",
    pushTimeRange: "推送时间区间",
    messageDetail: "消息详情",
    amount: "金额",
    enterAmount: "请输入金额",
    push: "推送",
    status: "消息状态",
    result0: "成功",
    result1: "等待响应",
    result2: "推送超时",
    result3: "设备忙，消息被丢弃",
    result4: "设备离线",
    result5: "设备异常",
    messageTotalNumber: "消息总数",
    messageTotalNumberSuffix: "消息总数(条)",
    broadcastAmountNumber: "播报总金额",
    amountSuffix: "收款金额(元)",
    weekMessageTrend: "近一周消息播报趋势图",
    weekAmountTrend: "近一周收款金额趋势图",
    pushAudio: "推送Mp3文件（仅试听演示）",
    audioFile: "音频文件",
    selectFile: "请选择小于40Kb的Mp3文件"
}

export default message
